import React, {useEffect} from 'react';
import { getActiveGenres } from '../../actions/filterActions';
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom';
import Slider from '../slides/Slider';


function Genres(props) {

    const dispatch = useDispatch()

    const navigate = useNavigate()

    const { activeGenres} = useSelector(state => state.activeGenres)

    useEffect(()=>{

        if (!activeGenres || !activeGenres.length){
            dispatch(getActiveGenres())
        }

    },[dispatch])

    const clickHandler = (item) => {
        props.setFilterList([[item.id, item.title, 4]])
        props.setActiveComponent(4)
        navigate(`/filter_results/${item.id}!4`)

    }


    return (
        <div>
        <div className="col-12" style = {{marginTop:"2.5vw"}}>
            <div className="d-flex align-items-center justify-content-start">
                <span className="text-white ps-2 ps-md-4 pe-0 pe-md-3 slide-title">Genres</span>
            </div>
            <div className='position-relative'>
                <Slider
                        num = {7}
                        type = {3}
                        showTitle = {false}
                        tvData={activeGenres}
                        slideClickHandler={clickHandler}
                    /> : ""
            </div>
        </div>
        </div>
    );
}

export default Genres;